module.exports = __webpack_public_path__ + "static/media/intel.c273d75b.png";